import { keyboardKey } from '../../keyboard-key';

/**
 * @specification
 * Adds attribute 'aria-disabled=true' based on the property 'disabled' to 'input' slot.
 * Adds attribute 'aria-required=true' based on the property 'required' to 'input' slot.
 * Adds attribute 'aria-invalid=true' based on the property 'error' to 'input' slot.
 * Triggers 'clear' action with 'Escape' on 'input'.
 */
export var inputBehavior = function inputBehavior(props) {
  return {
    attributes: {
      input: Object.assign({
        'aria-disabled': props.disabled
      }, props.required && {
        'aria-required': true
      }, props.error && {
        'aria-invalid': true
      })
    },
    keyActions: {
      input: {
        clear: {
          keyCombinations: [{
            keyCode: keyboardKey.Escape
          }]
        }
      }
    }
  };
};
//# sourceMappingURL=inputBehavior.js.map
